
import { Vue, Component, Prop } from "vue-property-decorator";
import { MarketPremiumInfo } from "zaehlerfreunde-proto-types/market_premium_pb";

@Component
export default class MarketPremiumItem extends Vue {
  @Prop()
  marketPremiumInfo: MarketPremiumInfo;
}
